<template lang="pug">
	.loader
</template>


<script>
export default {
  name: "Loader"
}
</script>


<style lang="scss" scoped>
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(540deg);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 currentColor;
    opacity: 0;
  }
  50% {
    box-shadow: 0 0 0 0 currentColor;
    opacity: 0.5;
  }
  100% {
    box-shadow: 0 0 0 bluerem(40px) currentColor;
    opacity: 0;
  }
}

.loader {
	height: 100vh;
	width: 100%;
  position: relative;
  z-index: 5;
  will-change: position, opacity;
  background: $white;
	color: rgba(25,25,25, .7);
  &:before {
    position: absolute;
    top: calc(45% - 45px);
    bottom: auto;
    left: 0;
    margin: auto;
    right: 0;
    width: bluerem(90px);
    height: bluerem(90px);
    content: "";
    animation: spin 1.5s ease infinite;
    border: bluerem(12px) solid transparent;
    border-top-color: currentColor;
    border-bottom-color: currentColor;
    border-radius: 50%;
    will-change: transform, opacity;
  }
  &:after {
    position: absolute;
    top: calc(45% - 45px);
    bottom: auto;
    left: 0;
    right: 0;
    width: bluerem(90px);
    height: bluerem(90px);
    border: bluerem(12px) solid transparent;
    margin: auto;
    animation: pulse 1.5s ease infinite;
    will-change: box-shadow, opacity;
    border-radius: 50%;
    content: "";
  }
}
</style>
